












import { Component, Prop, Emit, Vue } from "vue-property-decorator";

@Component
export default class Heder extends Vue {
  @Prop() private score!: number;
  @Prop() private time!: number;

  @Emit()
  resetGame() {}
}
